module.exports = __webpack_public_path__ + "img/emily_in_paris.f0453929.jpg";